import { ASSETS } from '../../../constants/assets'
import { HERO_USECASES, PAGE_TYPES } from '../../../constants/useCases.constants'
import ImgUtil from '../../../utils/img.utils'

export const getBackgroundProp = (
  heroData: any,
  data: any,
  imageSrc: string,
  focalPoint: any,
  backgroundVideoUrl: string,
  pageType: string,
  imageDimensions: any,
  isHomePage: boolean
) => {
  if (
    heroData.useCase !== HERO_USECASES.MINIMAL ||
    heroData.useCase === HERO_USECASES.FULL_WIDTH_HERO
  ) {
    heroData.cta = data.cta || []
    heroData.eyebrow = data.eyebrow

    let backgroundImgToUse = ''
    if (
      (pageType === PAGE_TYPES.SOLUTIONS || pageType === PAGE_TYPES.COMPANY_LISTING) &&
      heroData.useCase === HERO_USECASES.FULL_WIDTH_HERO
    ) {
      backgroundImgToUse = imageSrc
    } else if (pageType === PAGE_TYPES.SOLUTIONS) {
      backgroundImgToUse = ASSETS.HERO_SOLUTIONS_BACKGROUND
    } else if (pageType === PAGE_TYPES.COMPANY_LISTING) {
      backgroundImgToUse = ASSETS.HERO_COMPANY_LISTING_BACKGROUND
    } else {
      backgroundImgToUse = imageSrc
    }

    //* only set background props if not an event video background
    if (!backgroundVideoUrl) {
      const backgroundCoordinateX =
        focalPoint?.x && imageDimensions && imageDimensions.width
          ? (focalPoint.x / imageDimensions.width) * 95
          : '50'

      const backgroundCoordinateY =
        focalPoint && focalPoint.y && imageDimensions && imageDimensions.height
          ? (focalPoint.y / imageDimensions.height) * 100
          : '50'

      const gravityX =
        focalPoint && focalPoint.x && imageDimensions && imageDimensions.width
          ? focalPoint.x / imageDimensions.width
          : '0.50'

      const gravityY =
        focalPoint && focalPoint.y && imageDimensions && imageDimensions.height
          ? focalPoint.y / imageDimensions.height
          : '0.50'

      const mobileImgSrc = isHomePage
        ? `width=1920`
        : `width=768,height=270,fit=cover,gravity=${gravityX}x${gravityY}`

      return {
        $img: ImgUtil.getResizedImageUrl(backgroundImgToUse, `width=3840`),
        $tablet_img: ImgUtil.getResizedImageUrl(backgroundImgToUse, `width=1920`),
        $mobile_img: ImgUtil.getResizedImageUrl(backgroundImgToUse, mobileImgSrc),
        $mobile_xs_img: isHomePage || false,
        $backgroundPosX: backgroundCoordinateX,
        $backgroundPosY: backgroundCoordinateY,
      }
    }
  } else {
    return null
  }
}
